import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import {
  ELEMENT_BULLET_POINT,
  ELEMENT_BULLET_POINT_CHECK,
  ELEMENT_BULLET_POINT_LIST_ITEM,
  ELEMENT_BULLET_POINT_NUMBER,
  ELEMENT_BULLET_POINT_QUESTION,
  ELEMENT_BULLET_POINT_X,
} from './BulletPointPlugin.types';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const ListItemElement = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import(/* webpackExports: "ListItemElement" */ './element/readOnly/ListItemElement').then(
      (mod) => mod.ListItemElement
    )
  )
);
const OrderedListElementReadOnly = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import(/* webpackExports: "OrderedListElementReadOnly" */ './element/OrderedListElement').then(
      (mod) => mod.OrderedListElementReadOnly
    )
  )
);
const UnorderedListCheckElementReadOnly = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import(
      /* webpackExports: "UnorderedListCheckElementReadOnly" */ './element/UnorderedListCheckElement'
    ).then((mod) => mod.UnorderedListCheckElementReadOnly)
  )
);
const UnorderedListElementReadOnly = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import(
      /* webpackExports: "UnorderedListElementReadOnly" */ './element/UnorderedListElement'
    ).then((mod) => mod.UnorderedListElementReadOnly)
  )
);
const UnorderedListOElementReadOnly = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import(
      /* webpackExports: "UnorderedListOElementReadOnly" */ './element/UnorderedListOElement'
    ).then((mod) => mod.UnorderedListOElementReadOnly)
  )
);
const UnorderedListXElementReadOnly = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import(
      /* webpackExports: "UnorderedListXElementReadOnly" */ './element/UnorderedListXElement'
    ).then((mod) => mod.UnorderedListXElementReadOnly)
  )
);

export const BulletPointReadOnlyPlugin = (): SlatePlugin => {
  return {
    renderElement: (renderProps: RenderElementProps) => {
      const { element } = renderProps;
      switch (element.type) {
        case ELEMENT_BULLET_POINT: {
          return <UnorderedListElementReadOnly {...renderProps} />;
        }
        case ELEMENT_BULLET_POINT_CHECK: {
          return <UnorderedListCheckElementReadOnly {...renderProps} />;
        }
        case ELEMENT_BULLET_POINT_X: {
          return <UnorderedListXElementReadOnly {...renderProps} />;
        }
        case ELEMENT_BULLET_POINT_QUESTION: {
          return <UnorderedListOElementReadOnly {...renderProps} />;
        }
        case ELEMENT_BULLET_POINT_NUMBER: {
          return <OrderedListElementReadOnly {...renderProps} />;
        }
        case ELEMENT_BULLET_POINT_LIST_ITEM: {
          return <ListItemElement {...renderProps} />;
        }
      }
    },
  };
};
